import React, { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import logo from "../images/healthequity-wageworks-logo-white.png";
import { Grid, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import Routes from "./Routes";
import { Brand, CredentialResponse, UserType } from "../services/Types";
import UserCredentialsApi from "../services/Api";
import { createCustomizedTheme } from "./MuiTheme";
import LogoutButton from "./LogoutButton/LogoutButton";
import jwt from "jwt-decode";


const useStyles = makeStyles({
  appBar: {
    backgroundColor: "#fff !important",
    color: "#474747 !important",
  },
  toolBar: {
    paddingLeft: "0 !important",
    height: "90px",
  },
  logoBox: {        
    width: "130px",
    textAlign: "center",
    "& a": {
      display: "inline-block",
      width: "100%",
    },
  },
  logo: {    
    verticalAlign: "middle",
    display: "inline-block",
    width: "84px",
    height: "28px",
    margin: "0 auto",
  },
  user: {
    fontFamily: "SF Pro Display",
    color: "#323232",
    fontWeight: "700",
    size: "12px",
    lineHeight: "14.32px",
    align: "right"
  },
  avatar: {
    backgroundColor: "#474747 !important",
    marginLeft: "16px",
  },
});

function NavBar({ userType, credentialId } : { userType: string | null | undefined, credentialId: string }) {

  let logoUrl: string | null;
  const classes = useStyles();
  const auth = useAuth();
  const userCredentialsApi = new UserCredentialsApi();
  const defaultTheme = createCustomizedTheme({});
  const [theme, setTheme] = useState<Theme>(defaultTheme);
  const [loggedInCredential, setUserCredentials] = useState<CredentialResponse>();
  const [brand, setBrand] = useState<Brand>();  
  const { error, signinSilent } = useAuth();    

  let loggedInCredentialId : string = ""
  let internalUserLoggedInUserName : string = ""

  if(userType === UserType.EXTERNAL && auth.user?.access_token)
  {
    let jwtPayload = jwt(auth.user?.access_token) as any;
    loggedInCredentialId = jwtPayload["UnifiedCredentialId"] as string;
  }
  
  if(userType === UserType.INTERNAL && auth.user?.id_token)
  {    
    let jwtPayload = jwt(auth.user?.id_token) as any;
    internalUserLoggedInUserName = jwtPayload["name"]  as string;
  } 
    
  useEffect(() => {
           
    const init = async () => {  
      
      if(userType === UserType.EXTERNAL)
      {
          await userCredentialsApi.init(auth.user?.access_token, signinSilent);

          const credentialResponse = await userCredentialsApi.getCredentialsById(loggedInCredentialId);
          setUserCredentials(credentialResponse);

          const brandResponse: Brand = await userCredentialsApi.getBranding();
          setBrand(brandResponse);
          const customTheme = createCustomizedTheme({
            actionItemColor: brandResponse.actionItemColor ? brandResponse.actionItemColor : undefined,
            actionItemHoverColor: brandResponse.actionItemHoverColor,
          });
              
          setTheme(customTheme);
      }         
    }    
    init();
  }, []);

  // Get logo from branding if available, else use default logo
  logoUrl = brand?.logoUrl ? brand.logoUrl : logo;

  return (
    <AppBar className={classes.appBar} position="static">
      <Toolbar className={classes.toolBar} variant="dense">
        <Box
          className={classes.logoBox}
          sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
        >
          <Link to={Routes.home}>
            <img className={classes.logo} alt="HealthEquity Logo" src={logoUrl} />
          </Link>
        </Box>
        <Box sx={{ flexGrow: 1 }}></Box>
                   
            <Grid container direction="column" justifyContent="flex-end" alignItems="flex-end" rowSpacing={1} >
              <Grid item xs="auto" >

                <span className={classes.user}>

                    { userType === UserType.EXTERNAL ? `${loggedInCredential?.profiles?.[0]?.firstName ?? ""} ${loggedInCredential?.profiles?.[0]?.lastName ?? ""}` 
                                                     : `${internalUserLoggedInUserName ?? ""}`
                    }
                </span>
               
              </Grid>
              <Grid item xs="auto" ><LogoutButton /></Grid>            
            
        </Grid>
        {error && <LogoutButton />}
      </Toolbar>
    </AppBar>
  );
}

export default NavBar;


